// extracted by mini-css-extract-plugin
export var collapsedSummary = "_rh-0";